/**
 * Wie er meedoen onder dit account.
 *
 * Een groepsgenoot bevestigt met eigen gebruikersnaam en wachtwoord; het
 * ondertekende bewijs uit /student/groepslid komt in de lijst en gaat mee
 * bij het aanmaken van het groepje. Er staat nooit een wachtwoord in de
 * state van dit onderdeel: het formulier wordt na een bevestiging geleegd.
 */
import React, { useState } from 'react';
import { kleur } from '../../../theme/tokens';
import { basis } from '../stijlen';

export const MAX_GENOTEN = 2;

export function Groepsgenoten({ api, sessionId, user, genoten, onWijzig }) {
  const [form, setForm] = useState({ username: '', password: '' });
  const [fout, setFout] = useState('');
  const [bezig, setBezig] = useState(false);

  const voegToe = async () => {
    if (!form.username.trim() || !form.password) {
      setFout('Vul de gebruikersnaam en het wachtwoord in.');
      return;
    }
    setBezig(true);
    setFout('');
    try {
      const data = await api.bevestigGroepslid(sessionId, form.username.trim(), form.password);
      if (data.success) {
        // Als functie, zodat wat er tijdens het wachten in de groepsnaam of
        // het icoon is veranderd niet wordt overschreven.
        onWijzig(prev => [...prev, data.data]);
        setForm({ username: '', password: '' });
      } else {
        setFout(data.detail || 'Dat lukte niet.');
      }
    } catch (err) {
      setFout('Geen verbinding. Probeer het nog een keer.');
    } finally {
      setBezig(false);
    }
  };

  const haalWeg = (id) => {
    onWijzig(prev => prev.filter(g => g.id !== id));
    setFout('');
  };

  return (
    <div style={styles.formGroup}>
      <label style={styles.label}>Wie werken er met je mee?</label>
      <p style={styles.uitleg}>
        Jullie werken samen onder het account van {user.naam}. Je groepsgenoten
        hoeven niet apart in te loggen — ze typen hier alleen even hun eigen
        gebruikersnaam en wachtwoord, zodat hun naam bij het groepje komt te staan.
        Werk je alleen? Laat dit dan leeg.
      </p>

      <div style={styles.genootRij}>
        <span style={styles.genootZelf}>{user.naam} (jij)</span>
        {genoten.map(g => (
          <span key={g.id} style={styles.genoot}>
            {g.naam}
            <button onClick={() => haalWeg(g.id)} style={styles.genootWeg} title="Haal weg">×</button>
          </span>
        ))}
      </div>

      {genoten.length < MAX_GENOTEN ? (
        <div style={styles.genootForm}>
          <input type="text" autoComplete="off" placeholder="Gebruikersnaam groepsgenoot"
            value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} style={styles.input} />
          <input type="password" autoComplete="new-password" placeholder="Wachtwoord"
            value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            onKeyDown={(e) => { if (e.key === 'Enter') voegToe(); }} style={styles.input} />
          <button onClick={voegToe} disabled={bezig} style={styles.btnSecondary}>
            {bezig ? 'Even kijken…' : 'Erbij zetten'}
          </button>
        </div>
      ) : (
        <p style={styles.uitleg}>Een groepje is maximaal drie leerlingen. Vol.</p>
      )}
      {fout && <p style={styles.genootFout}>{fout}</p>}
    </div>
  );
}

export const formulierStijlen = {
  formGroup: { marginBottom: '20px' },
  label: { display: 'block', marginBottom: '8px', fontWeight: 'bold', color: kleur.inkt },
  input: { width: '100%', padding: '14px', border: `2px solid ${kleur.lijn}`, borderRadius: '8px', fontSize: '16px', boxSizing: 'border-box' },
  genootFout: { color: kleur.roodDonker, fontSize: '14px', margin: '8px 0 0' },
};

const styles = {
  ...basis,
  ...formulierStijlen,
  genootRij: { display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' },
  genootZelf: { background: kleur.accentLicht, color: kleur.accentTekst, padding: '6px 12px', borderRadius: '14px', fontSize: '14px' },
  genoot: { background: kleur.groenLicht, color: kleur.groenTekst, padding: '6px 6px 6px 12px', borderRadius: '14px', fontSize: '14px', display: 'inline-flex', alignItems: 'center', gap: '6px' },
  genootWeg: { border: 'none', background: 'transparent', cursor: 'pointer', fontSize: '16px', lineHeight: 1, color: kleur.groenTekst, padding: '0 4px' },
  genootForm: { display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' },
};
